import {ServiceBase} from "../ServiceBase";
import {IPixiAppService, IPixiAppCreateOptions, IPixiAppCreationResult, Application, Loader, Dict, LoaderResource} from "./pixi-app.service.interface";
import {createPixiApplication} from "./pixi-app-creator";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

/**
 * This service will manage pixi applications.
 *
 */
export class PixiAppService extends ServiceBase implements IPixiAppService {
    private _pixiAppCreatorWithWebGlManager: (options: IPixiAppCreateOptions) => Promise<IPixiAppCreationResult>;

    constructor(services: IServiceFactoryExtended) {
        super(services);
        this._pixiAppCreatorWithWebGlManager = this.services.webGlContextManager.makeCreator<IPixiAppCreateOptions, IPixiAppCreationResult>(createPixiApplication);
    }
    public createPixiApp(options: IPixiAppCreateOptions) {
        if (options.force2DCanvasContext) {
            return createPixiApplication(options);
        }
        return this._pixiAppCreatorWithWebGlManager(options);
    }

    public loadResources(pixiApp: Application, resourcesUrls: {name: string, jsonUrl: string}[]) {
        return new Promise<{loader: Loader; resources: Dict<LoaderResource>;}>((res, rej) => {
            resourcesUrls.forEach(({name, jsonUrl}) => {
                pixiApp.loader.add(name, jsonUrl);
            });
            pixiApp.loader.load(async (loader, resources) => {
                /* This happens for example if we use "@pixi-spine/runtime-3.8" library instead of "pixi-spine" or "@pixi-spine/all-3.8" */
                /* Also it happens if the json is not well formatted according to specs (RFC-8259, ECMA-404) (https://www.json.org/json-en.html , https://en.wikipedia.org/wiki/JSON).
                For example, all members have to be quoted, or else is not a JSON but an object. Ex: NOT OK: {key: "value"} / OK: {"key": "value"}
                I like to use this validator+formatter: https://elmah.io/tools/json-formatter/ */
                /* Otherwise, this shouldn't happen normally, but since the member is optional in typings, better safe than sorry */
                resourcesUrls.forEach(({name}) => {
                    if (!resources[name].spineData) {
                        rej("Error occured. Could not load the animation");
                    }
                });
                res({loader, resources});
            });
        });
    }
}
